var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C3 2.89543 3.89543 2 5 2H18C19.1046 2 20 2.89543 20 4V10.8027C19.1175 10.2922 18.0929 10 17 10C16.4906 10 15.9961 10.0635 15.5238 10.183C15.3405 10.0677 15.1166 10 14.875 10H8.125C7.50368 10 7 10.4477 7 11C7 11.5523 7.50368 12 8.125 12H12.5278C12.0113 12.5771 11.6048 13.2548 11.3414 14H8.125C7.50368 14 7 14.4477 7 15C7 15.5523 7.50368 16 8.125 16H11C11 19.3137 13.6863 22 17 22H5C3.89543 22 3 21.1046 3 20V4ZM7 7C7 6.44772 7.50368 6 8.125 6H14.875C15.4963 6 16 6.44772 16 7C16 7.55229 15.4963 8 14.875 8H8.125C7.50368 8 7 7.55229 7 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18.6458C19.2671 19.4762 18.1947 20 17 20C14.7909 20 13 18.2091 13 16C13 13.7909 14.7909 12 17 12C18.1947 12 19.2671 12.5238 20 13.3542C20.6224 14.0593 21 14.9856 21 16C21 17.0144 20.6224 17.9407 20 18.6458ZM19.7469 15.6642C20.1138 15.2515 20.0766 14.6194 19.6638 14.2525C19.251 13.8855 18.619 13.9227 18.252 14.3355L16.3328 16.4947L15.7469 15.8355C15.3799 15.4227 14.7479 15.3855 14.3351 15.7525C13.9223 16.1194 13.8851 16.7515 14.252 17.1642L15.5854 18.6642C15.7751 18.8777 16.0471 18.9999 16.3328 18.9999C16.6184 18.9999 16.8904 18.8777 17.0802 18.6642L19.7469 15.6642Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestFill);
export default __webpack_public_path__ + "static/media/request-fill.5b527ce4.svg";
export { ForwardRef as ReactComponent };